module.exports = __webpack_public_path__ + "img/backyard-patio.62e5dcd4.webp";